import { makeStyles } from 'tss-react/mui'
import { lato } from '@styles/fonts'
import Noise from 'src/assets/images/campaigns/noise.png'
import Img from 'src/assets/images/getInvolved/joinCommuinty.jpg'

import { nunito_sans } from '@styles/fonts'
const useStyles = makeStyles()((theme) => ({
  outerContainer: {
    height: 'auto',
    textAlign: 'center',
    display: 'flex',
    justifyContent: 'center',
    marginTop: '-3.8rem',
    position: 'relative',
    zIndex: '222',
    [theme.breakpoints.down('md')]: {
      marginTop: '-2rem',
    },
  },

  innerContainer: {
    maxWidth: theme.maxWidth,
    background: `url(${Noise.src}) white`,
    borderRadius: '60px',
    padding: theme.spacing(15, 16, 22),
    marginBottom: theme.spacing(20),
    [theme.breakpoints.down('md')]: {
      padding: theme.spacing(10, 0, 15),
      borderRadius: '40px',
      marginBottom: theme.spacing(14),
    },
  },
  title: {
    fontFamily: nunito_sans.style.fontFamily,
    fontStyle: 'normal',
    fontWeight: 800,
    fontSize: '72px',
    textAlign: 'center',
    textTransform: 'uppercase',
    lineHeight: '84px',
    color: theme.custom.blackColor,
    padding: theme.spacing(4, 4, 0),

    [theme.breakpoints.down('md')]: {
      width: '100%',
      fontSize: '34px',
      lineHeight: '55px',
    },
  },

  desc: {
    fontFamily: lato.style.fontFamily,
    fontStyle: 'normal',
    fontWeight: 400,
    fontSize: '20px',
    textAlign: 'center',
    lineHeight: '24px',
    color: theme.custom.blackColor,
    width: '70%',
    margin: 'auto',
    padding: theme.spacing(3, 4, 15),

    [theme.breakpoints.down('md')]: {
      width: '100%',

      fontSize: '14px',
      lineHeight: '19px',
    },
  },
  cardWrapper: {
    backgroundImage: `url(${Img?.src})`,
    backgroundRepeat: 'no-repeat',
    borderRadius: '40px',
    backgroundPosition: 'center',
    backgroundSize: 'cover',
    padding: theme.spacing(7, 7),

    [theme.breakpoints.down('md')]: {
      padding: theme.spacing(6, 4),
    },
  },
  zenBg: {
    backgroundImage: 'none',
  },
  headerWrapper: {
    h6: {
      marginBottom: '4rem',
      [theme.breakpoints.down('md')]: {
        marginBottom: '2rem',
      },
    },

    h1: {
      [theme.breakpoints.down('md')]: {
        width: '100%',
        fontSize: '40px',
      },
    },
    '& .MuiTypography': {
      [theme.breakpoints.down('md')]: {
        width: '100%',
      },
    },
    div: {
      textAlign: 'center',

      [theme.breakpoints.down('md')]: {
        marginBottom: '0rem',
        textAlign: 'center',
      },
    },
  },
}))

export default useStyles
